<template>
  <div
    v-if="showed"
    class="button-wrapper"
  >
    <div
      v-show="buttonRendered"
      :class="{
        'disabled-payment': disabled,
      }"
      id="payment-request-button"
    />
  </div>
</template>

<script>
import paymentMixin from "../payment-mixin";

export default {
  name: "StripeAppleGooglePay",
  mixins: [paymentMixin],
  props: {
    paymentRequestOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => ({
    buttonStyle: {
      paymentRequestButton: {
        type: "default",
        theme: "light",
        height: "51px",
        borderRadius: "8px",
      },
    },
    buttonRendered: false,
    paymentRequest: {},
    stripe: {},
  }),
  created() {
    if (!this.showed) return;
    this.stripe = window.Stripe(
      process.env.VUE_APP_PAYMENT_STRIPE_PUBLISH_KEY,
      {
        locale: this.$i18n.locale,
      }
    );

    this.paymentRequest = this.stripe.paymentRequest(
      this.paymentRequestOptions
    );
    this.paymentRequest.on("token", this.processPayment);

    this.paymentRequest.canMakePayment().then((canMakePayment) => {
      if (!canMakePayment) {
        this.buttonRendered = false;
      } else {
        let prButton = undefined;
        if (
          canMakePayment.googlePay &&
          this.business.enabledPaymentMethods.includes("GooglePay")
        ) {
          // this.$emit("update:cardButtonColor", "#5f6368");
          prButton = this.stripe.elements().create("paymentRequestButton", {
            paymentRequest: this.paymentRequest,
            style: this.buttonStyle,
          });
          prButton.mount("#payment-request-button");
          this.$amplitude.logEvent("Payment page event User has google pay", {
            qrCode: this.$route.params.qrCode,
          });
          this.$axios.post("/api/v1/fe-status", {
            status: 200,
            message: "Payment page event User has google pay",
            qrCode: this.$route.params.qrCode,
            timestamp: Date.now(),
          });
        }
        if (
          canMakePayment.applePay &&
          this.business.enabledPaymentMethods.includes("ApplePay")
        ) {
          prButton = this.stripe.elements().create("paymentRequestButton", {
            paymentRequest: this.paymentRequest,
            style: this.buttonStyle,
          });
          prButton.mount("#payment-request-button");
          this.$amplitude.logEvent("Payment page event User has apple pay", {
            qrCode: this.$route.params.qrCode,
          });
          this.$axios.post("/api/v1/fe-status", {
            status: 200,
            message: "Payment page event User has apple pay",
            qrCode: this.$route.params.qrCode,
            timestamp: Date.now(),
          });
        }
        if (prButton) {
          this.buttonRendered = true;
          prButton.on("click", () => {
            this.$amplitude.logEvent(
              `Payment page event ${
                canMakePayment.applePay ? "Apple Pay" : "Google Pay"
              } button clicked`,
              {
                qrCode: this.$route.params.qrCode,
              }
            );
          });
        }
      }

      this.$emit("stripeAppleGooglePayRendered", this.buttonRendered);
    });
  },
  methods: {
    processPayment(paymentData) {
      this.$axios
        .post("/api/v1/tx", {
          clientPaysFee: !!this.clientPaysFee,
          qrCodes: this.paymentObject,
          amount: this.amount,
          currency: this.currency,
          payData: JSON.stringify(paymentData.token),
          payerEmail: paymentData.payerEmail || "",
        })
        .then((response) => {
          if (
            response.data.status === "Success" &&
            response.data?.payload?.txId
          ) {
            if (
              paymentData.methodName === "apple-pay" ||
              paymentData.methodName === "google-pay"
            ) {
              paymentData.complete("success");
            }
            this.$router.push({
              name: "Receipt",
              params: { transactionId: response.data.payload.txId },
            });
          } else {
            if (
              paymentData.methodName === "apple-pay" ||
              paymentData.methodName === "google-pay"
            ) {
              paymentData.complete("fail");
            }
          }
        })
        .catch(() => {
          if (
            paymentData.methodName === "apple-pay" ||
            paymentData.methodName === "google-pay"
          ) {
            paymentData.complete("fail");
          }
        });
    },
  },
  watch: {
    amount: function(value) {
      if (value) {
        this.paymentRequest.update({
          total: {
            label: this.description,
            amount: value,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button-wrapper {
  margin: 12px auto 0 auto;
}

#payment-request-button::v-deep {
  border: 1px solid #2c2e2f !important;
  border-radius: 4px !important;
  overflow: hidden;

  .__PrivateStripeElement {
    box-shadow: none !important;
  }
}

.youtube-player {
  width: 100%;
}
</style>
